import { create } from 'zustand';

type TopMessage = {
  isMessageOpen: boolean;
  toggleMessage: (state: boolean) => void;
};

const useMessageStore = create<TopMessage>((set) => ({
  isMessageOpen: true,
  toggleMessage: (state: boolean) => set({ isMessageOpen: state }),
}));

export { useMessageStore };
